import classes from '../../targetMarketPlan.module.scss';
import { useTargetMarketShate } from '../../useTargetMarketShare';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useTMSViewTable } from './useTMSViewTable';
import { Dropdown } from 'primereact/dropdown';

const TMSViewTable = () => {
  const { getSalesSummaryVal, isSalesDetailsLoading } = useTargetMarketShate();
  const {
    directCOT,
    msplanPeriod,
    tmsPlanningMonth,
    isTMSPlanViewDataLoading,
    msplanPlanningPeriod,
    isMSplanPlanningPeriodLoading,
    setDirectCOT,
    getValues,
    handleOptionChange,
  } = useTMSViewTable();

  return (
    <div>
      <div className={classes.planDetailsContainer}>
        <h4>
          <div>
            <span>Choose Plan:</span>
          </div>

          <div className={classes.planningPeriodDropdown}>
            <Dropdown
              disabled={msplanPlanningPeriod.length === 0}
              value={msplanPeriod}
              options={msplanPlanningPeriod}
              loading={isMSplanPlanningPeriodLoading}
              optionLabel="label"
              onChange={e => {
                handleOptionChange(e.target.value);
              }}
              style={{ width: '15rem' }}
            />
          </div>
        </h4>
        {/* Direct Container start */}
        <div className={classes.directContainer}>
          <div>
            <p
              style={{
                fontSize: '20px',
                marginLeft: '1rem',
                fontWeight: '600',
                color: '#4D2E6D',
              }}
            >
              Direct
            </p>
            <div className={classes.saleDetails}>
              <div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                  }}
                >
                  YTD:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directCOT.value, 'YTD', 'direct')
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>
                  3MA:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directCOT.value, '3MA', 'direct')
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    paddingRight: '3rem',
                  }}
                >
                  PM:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directCOT.value, 'PM', 'direct')
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className={classes.directRadioGrp}>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directCOT.label === 'CMOP'}
                  onClick={() => {
                    setDirectCOT(() => ({
                      label: 'CMOP',
                      value: 'cmop',
                    }));
                  }}
                />
                <label htmlFor="cmop">CMOP</label>
              </span>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directCOT.label === 'VA Facility'}
                  onClick={() => {
                    setDirectCOT(() => ({
                      label: 'VA Facility',
                      value: 'va facility',
                    }));
                  }}
                />
                <label htmlFor="va">VA Facility</label>
              </span>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directCOT.label === 'TMOP'}
                  onClick={() => {
                    setDirectCOT(() => ({
                      label: 'TMOP',
                      value: 'tmop',
                    }));
                  }}
                />
                <label htmlFor="tmop">TMOP</label>
              </span>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directCOT.label === 'MTF'}
                  onClick={() => {
                    setDirectCOT(() => ({ label: 'MTF', value: 'mtf' }));
                  }}
                />
                <label htmlFor="mtf">MTF</label>
              </span>
            </div>
          </div>
          <div>
            <div className={classes.planTable}>
              <table>
                <thead>
                  <th>
                    <td>Planning Period</td>
                  </th>
                  <th>
                    <td>Strat Code</td>
                  </th>
                  <th>
                    <td>TMS</td>
                  </th>
                  <th>
                    <td>MS Plan</td>
                  </th>
                </thead>
                <tbody>
                  {tmsPlanningMonth.map((_, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{tmsPlanningMonth[idx].label}</td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {!isTMSPlanViewDataLoading ? (
                            getValues(
                              directCOT.value,
                              'direct',
                              tmsPlanningMonth[idx].dateString,
                              'stratcode'
                            )
                          ) : (
                            <ProgressSpinner
                              style={{
                                width: '10px',
                                height: '10px',
                                padding: 0,
                                margin: 0,
                              }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {!isTMSPlanViewDataLoading ? (
                            getValues(
                              directCOT.value,
                              'direct',
                              tmsPlanningMonth[idx].dateString,
                              'tmsval'
                            )
                          ) : (
                            <ProgressSpinner
                              style={{
                                width: '10px',
                                height: '10px',
                                padding: 0,
                                margin: 0,
                              }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                        <td style={{ fontWeight: '600' }}>
                          {!isTMSPlanViewDataLoading ? (
                            getValues(
                              directCOT.value,
                              'direct',
                              tmsPlanningMonth[idx].dateString,
                              'msplan'
                            )
                          ) : (
                            <ProgressSpinner
                              style={{
                                width: '10px',
                                height: '10px',
                                padding: 0,
                                margin: 0,
                              }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Direct Container end */}
        <hr />
        {/* Indirect Container start */}
        <div className={classes.directContainer}>
          <div>
            <p
              style={{
                fontSize: '20px',
                marginLeft: '1rem',
                fontWeight: '600',
                color: '#4D2E6D',
              }}
            >
              Indirect
            </p>
            <div className={classes.saleDetails}>
              <div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                  }}
                >
                  YTD:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directCOT.value, 'YTD', 'indirect')
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>
                  3MA:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directCOT.value, '3MA', 'indirect')
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    paddingRight: '3rem',
                  }}
                >
                  PM:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directCOT.value, 'PM', 'indirect')
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div>
            <div className={classes.planTable}>
              <table>
                <thead>
                  <th>
                    <td>Planning Period</td>
                  </th>
                  <th>
                    <td>Strat Code</td>
                  </th>
                  <th>
                    <td>TMS</td>
                  </th>
                  <th>
                    <td>MS Plan</td>
                  </th>
                </thead>
                <tbody>
                  {tmsPlanningMonth.map((_, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{tmsPlanningMonth[idx].label}</td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {!isTMSPlanViewDataLoading ? (
                            getValues(
                              directCOT.value,
                              'indirect',
                              tmsPlanningMonth[idx].dateString,
                              'stratcode'
                            )
                          ) : (
                            <ProgressSpinner
                              style={{
                                width: '10px',
                                height: '10px',
                                padding: 0,
                                margin: 0,
                              }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {!isTMSPlanViewDataLoading ? (
                            getValues(
                              directCOT.value,
                              'indirect',
                              tmsPlanningMonth[idx].dateString,
                              'tmsval'
                            )
                          ) : (
                            <ProgressSpinner
                              style={{
                                width: '10px',
                                height: '10px',
                                padding: 0,
                                margin: 0,
                              }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>

                        <td style={{ fontWeight: '600' }}>
                          {!isTMSPlanViewDataLoading ? (
                            getValues(
                              directCOT.value,
                              'indirect',
                              tmsPlanningMonth[idx].dateString,
                              'msplan'
                            )
                          ) : (
                            <ProgressSpinner
                              style={{
                                width: '10px',
                                height: '10px',
                                padding: 0,
                                margin: 0,
                              }}
                              strokeWidth="8"
                              fill="var(--surface-ground)"
                              animationDuration="1s"
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Indirect Container end */}
      </div>
    </div>
  );
};

export default TMSViewTable;
